import { render } from "./sidebar.vue?vue&type=template&id=b76cf4ae"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__